import { render, staticRenderFns } from "./teamlist.vue?vue&type=template&id=16a801fa&scoped=true&"
import script from "./teamlist.vue?vue&type=script&lang=js&"
export * from "./teamlist.vue?vue&type=script&lang=js&"
import style0 from "./teamlist.vue?vue&type=style&index=0&id=16a801fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a801fa",
  null
  
)

export default component.exports